import React, { useState } from 'react';
import Cross from '../shared/Cross';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { useAddVoucherMutation } from '../../services/basket.api';
import { pathMW } from '../../helpers/routingHelpers';
import { setCheckoutCompletePath } from '../../store/sessionSlice';
import errorIcon from '../../img/icons/error.svg';

export const OfferModal = ({ state, onClose, isMobileModal }) => {
  const [voucherCodeInput, setVoucherCodeInput] = useState('');
  const [isError, setIsError] = useState(false);
  const [addVoucher, { isLoading, reset }] = useAddVoucherMutation();
  const [voucherNotLinked, setVoucherNotLinked] = useState(false);
  const [errorMessage, setErrorMessage] = useState([]);

  const { customer } = useSelector(state => state.session);
  const basket = useSelector(state => state.basket);
  const path = window.location.pathname;
  const dispatch = useDispatch();

  const offer = state.offer;

  const formatVoucherInput = (e) => {
    setVoucherCodeInput(e.target.value.trim().toUpperCase());
  };

  const clearState = () => {
    setVoucherCodeInput('');
    setIsError(false);
    setVoucherNotLinked(false);
    setErrorMessage([]);
    reset();
  };

  const handleAddVoucher = async () => {
    const value = voucherCodeInput;
    if (isError) {
      setIsError(false);
    }

    if (value.length > 0) {
      const { data } = await addVoucher({ voucherCode: value });
      if (data?.voucherExceptions?.length > 0) {
        setIsError(true);
        setVoucherNotLinked(data.voucherExceptions[0]?.voucherNotLinked);
        setErrorMessage(data.voucherExceptions[0]?.message);
      } else {
        clearState();
        state.resolve(true);
        onClose();
      }
    }
  };

  const handleClose = () => {
    clearState();
    state.reject();
    onClose();
  }

  return (
    <div className='offer-modal'>
      {!isMobileModal &&
        <Cross onClick={handleClose} absolute rightPosition={16} topPosition={16} />
      }
      <div className='offer-modal-container'>
        <div className='offer-modal-title-container'>
          <img src={offer.imageUrl} alt="Offer Image" className='title-image' />
          <h1 className='title-header'>{offer.externalName}</h1>
        </div>
        <p className='offer-modal-description'>
          {offer.description}
        </p>
        <div style={{ border: '1px solid #eae7e4' }}></div>
        <div className='offer-modal-voucher-container'>
          <p className='voucher-label'>
            YOUR VOUCHER CODE
          </p>
          <div className='voucher-input-apply-container'>
            <input
              id="offerModalVoucherInput"
              className="input voucher-input"
              type="text"
              autoComplete='off'
              placeholder="Enter voucher code"
              onChange={(e) => formatVoucherInput(e)}
              value={voucherCodeInput}
            />
            <button
              disabled={voucherCodeInput.length === 0 || isLoading}
              className='btn btn-primary'
              onClick={handleAddVoucher} >
              Apply
            </button>
          </div>
        </div>
      </div>
      {isError &&
        <div className="level is-mobile is-family-code" style={{ alignItems: 'start', ...(isMobileModal ? { padding: '0 1rem' } : { padding: '0'}) }}>
          <div className="level-item is-narrow is-shrinkable is-align-top">
            <i className="icon is-small" >
              <img id='InnerInputError' src={errorIcon} alt="error" />
            </i>
          </div>
          <div style={{ width: '80%' }} className="level-item is-growable  is-shrinkable is-justify-content-flex-start is-align-top">
            {
              errorMessage?.length > 0 && !voucherNotLinked ?
                <p key={errorMessage} className={'error-message'}>{errorMessage}</p>
                :
                null
            }
            {
              voucherNotLinked && customer !== null &&
              <p className={'error-message'}>Promotion is not valid with account. Could you try another one please?</p>
            }
            {
              voucherNotLinked && customer == null &&
              <p>
                Promotion is not valid without account. Please <Link to={pathMW('/checkout/login', basket.isDelivery)} onClick={(() => dispatch(setCheckoutCompletePath(path)))} id='logInLink'>Log in</Link> to use your Voucher.
              </p>
            }
          </div>
        </div>
      }
    </div>
  );
};